import { Grid, TextField, FormControlLabel, Switch } from "@mui/material";
import dayjs from "dayjs";
import { useState, useEffect, useContext } from "react";
import "dayjs/locale/es";
import Autocomplete from '@mui/material/Autocomplete';
import esArray from "src/general_components/functionEsArray";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { getCuentasLocalizaciones } from "src/projects/gestion_comercial/helpers/CuentasLocalizaciones";
import { TheLayoutContext } from "src/context/TheLayoutContext";

// Establecer español como idioma predeterminado
dayjs.locale("es");

const FormSimplificado = (data) => {
  // const { 
  //   toggleModal,
  //   setCambioPestania,
  //   cambioPestania } = data;

  const { setDataSearchFormBusquedaSimplificada, clienteSelectSimple, setClienteSelectSimple,
    clientesListSearch, ids_cuentas_localizaciones,
    setIdsCuentasLocalizaciones, dataSearchFormBusquedaSimplificada, idsCuentasLocalizaciones } = useContext(CajasContext);

      const { setClienteId } = useContext(TheLayoutContext)

  const [texto, setTexto] = useState(dataSearchFormBusquedaSimplificada?.data?.input_general || "");
  // Estados para Número
  const [habilitarRangoNumero, setHabilitarRangoNumero] = useState(false);
  const [numero, setNumero] = useState(dataSearchFormBusquedaSimplificada?.data?.input_numerico || "");
  const [numeroDesdeConcat, setNumeroDesdeConcat] = useState(dataSearchFormBusquedaSimplificada?.data?.input_numero_desde || "");
  const [numeroHastaConcat, setNumeroHastaConcat] = useState(dataSearchFormBusquedaSimplificada?.data?.input_numero_hasta || "");

  // Estados para Fecha
  const [habilitarRangoFecha, setHabilitarRangoFecha] = useState(false);
  const [fecha, setFecha] = useState(dataSearchFormBusquedaSimplificada?.data?.input_fecha || "");
  const [fechaDesdeConcat, setFechaDesdeConcat] = useState(dataSearchFormBusquedaSimplificada?.data?.input_fecha_desde || "");
  const [fechaHastaConcat, setFechaHastaConcat] = useState(dataSearchFormBusquedaSimplificada?.data?.input_fecha_hasta || "");


  const handleChange = (e) => {
    setTexto(e.target.value);
  };


  const handleclienteSelectSimple = async (cliente) => {
    setClienteSelectSimple(cliente);
    if (!cliente) {
      setClienteId(null);
      return;
    }
    setClienteId(cliente.id_cuentas)
    await getSectores(cliente);
  };


  const user_cuentas = JSON.parse(
    localStorage.getItem("siam-user-cuentas")
  );

  useEffect(() => {
    const datos_busqueda = {
      input_general: texto,
      input_numerico: habilitarRangoNumero ? "" : numero,
      input_numero_desde: habilitarRangoNumero ? numeroDesdeConcat : "",
      input_numero_hasta: habilitarRangoNumero ? numeroHastaConcat : "",
      input_fecha: habilitarRangoFecha ? "" : fecha,
      input_fecha_desde: habilitarRangoFecha ? fechaDesdeConcat : "",
      input_fecha_hasta: habilitarRangoFecha ? fechaHastaConcat : "",
    };
    setDataSearchFormBusquedaSimplificada({ data: datos_busqueda, cliente: clienteSelectSimple, ids_cuentas_localizaciones: ids_cuentas_localizaciones });


  }, [clienteSelectSimple, fecha, fechaDesdeConcat, fechaHastaConcat, habilitarRangoFecha, habilitarRangoNumero, ids_cuentas_localizaciones, numero, numeroDesdeConcat, numeroHastaConcat, setDataSearchFormBusquedaSimplificada, texto]);

  useEffect(() => {
    if (Array.isArray(dataSearchFormBusquedaSimplificada)) {
      setTexto("");
      setFecha("");
      setFechaDesdeConcat("");
      setFechaHastaConcat("");
      setNumero("");
      setNumeroDesdeConcat("");
      setNumeroHastaConcat("");
    }

  }, [dataSearchFormBusquedaSimplificada]);

  // Auto-seleccionar el cliente cuando hay uno solo
  useEffect(() => {
    const userCuentasArr = esArray(user_cuentas);
    if (userCuentasArr.length === 1 && clientesListSearch?.length > 0 && !clienteSelectSimple) {
      const soloCliente = clientesListSearch.find(c => c.id_cuentas === userCuentasArr[0].id_cuentas);
      if (soloCliente) {
        handleclienteSelectSimple(soloCliente);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientesListSearch]);

  const getSectores = async (cliente_seleccionado) => {
    let idsLocalizaciones = idsCuentasLocalizaciones;
    let promises = [];


    const user_cuentas = JSON.parse(localStorage.getItem("siam-user-cuentas")) || [];

    const user_cuentas_localizaciones = JSON.parse(
      localStorage.getItem("siam-user-cuentas-localizaciones")
    );


    if (esArray(user_cuentas).length === 1) {
      promises = esArray(user_cuentas).map((idCuenta) =>
        getCuentasLocalizaciones(idCuenta.id_cuentas)
      );
    } else if (cliente_seleccionado && esArray(cliente_seleccionado).length > 0) {
      promises = esArray(cliente_seleccionado).map((cliente) =>
        getCuentasLocalizaciones(cliente.id_cuentas)
      );
    }

    // Asegurar que promises es siempre un array válido
    if (promises.length === 0) {
      setIdsCuentasLocalizaciones([]);
      return;
    }

    const results = await Promise.all(promises);
    idsLocalizaciones = results.flat().filter(Boolean).map((item) => item.id);
    let idsLocalizaciones_filtrados = idsLocalizaciones;
    // Filtrar los objetos que tengan un id_cuentas_localizaciones presente en ids
    const filtrados = user_cuentas_localizaciones?.filter(obj => idsLocalizaciones.includes(obj.id_cuentas_localizaciones));
    if (user_cuentas_localizaciones && user_cuentas_localizaciones.length > 0) {
      const result = getCuentasLocalizacionesArray(filtrados);
      // Solo se setea si hay coincidencias en filtrados
      if (filtrados.length > 0) {
        idsLocalizaciones_filtrados = result;
        setIdsCuentasLocalizaciones(result);
      } else {
        setIdsCuentasLocalizaciones(idsLocalizaciones);
      }
    } else {
      idsLocalizaciones_filtrados = idsLocalizaciones;
      setIdsCuentasLocalizaciones(idsLocalizaciones_filtrados);
    }
  };

  const getCuentasLocalizacionesArray = (data) => {
    return data.map(item => item.id_cuentas_localizaciones);
  };

  const handleChangeSwitchFecha = () => {
    if (habilitarRangoFecha) {
      setFechaDesdeConcat("");
      setFechaHastaConcat("");
    } else {
      setFecha("");
    }
    setHabilitarRangoFecha(!habilitarRangoFecha);
  };


  const handleChangeSwitchNumerico = () => {
    if (habilitarRangoNumero) {
      setNumeroDesdeConcat("");
      setNumeroHastaConcat("");
    } else {
      setNumero("");
    }
    setHabilitarRangoNumero(!habilitarRangoNumero);
  };


  return (
    <div>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        {esArray(user_cuentas).length !== 1 && (
          <Grid item xs={8} sm={8} md={5} style={{ marginBottom: "1vh", marginTop: "4vh" }}>
            <AutoCompleteClientes
              clientes={clientesListSearch}
              onclienteSelectSimple={handleclienteSelectSimple}
              clienteSelectSimple={clienteSelectSimple}
            />
          </Grid>
        )}

        <Grid item xs={esArray(user_cuentas).length === 1 ? 12 : 8} sm={8} md={esArray(user_cuentas).length === 1 ? 6 : 5} style={{ marginBottom: "1vh", marginTop: "4vh" }}>
          <TextField
            id="nombre"
            fullWidth
            label="Texto"
            variant="outlined"
            value={texto}
            onChange={handleChange}
          />
        </Grid>

        {/* Fila de Número */}
        <Grid item xs={4} sm={4} md={4} style={{ marginBottom: "1vh", marginTop: "1vh" }}>
          <FormControlLabel
            control={
              <Switch
                checked={habilitarRangoNumero}
                onChange={handleChangeSwitchNumerico}
              />
            }
            label="Habilitar rango de Número"
          />
        </Grid>
        {habilitarRangoNumero ? (
          <>
            <Grid item xs={6} sm={4} md={3}>
              <TextField
                fullWidth
                type="number"
                label="Número Desde"
                variant="outlined"
                value={numeroDesdeConcat}
                onChange={(e) => setNumeroDesdeConcat(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={3}>
              <TextField
                fullWidth
                type="number"
                label="Número Hasta"
                variant="outlined"
                value={numeroHastaConcat}
                onChange={(e) => setNumeroHastaConcat(e.target.value)}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={esArray(user_cuentas).length === 1 ? 12 : 8} sm={8} md={esArray(user_cuentas).length === 1 ? 6 : 6} style={{ marginBottom: "1vh", marginTop: "1vh" }}>
            <TextField
              fullWidth
              type="number"
              label="Número"
              variant="outlined"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
            />
          </Grid>
        )}


        {/* Fila de Fecha */}
        <Grid item xs={4} sm={4} md={4} style={{ marginBottom: "4vh", marginTop: "1vh" }}>
          <FormControlLabel
            control={
              <Switch
                checked={habilitarRangoFecha}
                onChange={handleChangeSwitchFecha}
              />
            }
            label="Habilitar rango de Fecha"
          />
        </Grid>
        {habilitarRangoFecha ? (
          <>
            <Grid item xs={6} sm={4} md={3}>
              <TextField
                fullWidth
                type="date"
                label="Fecha Desde"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={fechaDesdeConcat}
                onChange={(e) => setFechaDesdeConcat(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={3}>
              <TextField
                fullWidth
                type="date"
                label="Fecha Hasta"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                value={fechaHastaConcat}
                onChange={(e) => setFechaHastaConcat(e.target.value)}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={esArray(user_cuentas).length === 1 ? 12 : 8} sm={8} md={esArray(user_cuentas).length === 1 ? 6 : 6} style={{ marginBottom: "4vh", marginTop: "1vh" }}>
            <TextField
              fullWidth
              type="date"
              label="Fecha"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </Grid>
        )}


        {/* <Grid item>
          <Button variant="outlined" color="secondary" onClick={handleClear}>
            Limpiar
          </Button>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default FormSimplificado;

const AutoCompleteClientes = ({ clientes, onclienteSelectSimple, clienteSelectSimple }) => {
  return (
    <Autocomplete
      options={clientes || []}
      onChange={(event, value) => onclienteSelectSimple(value)}
      fullWidth
      getOptionLabel={(option) => option.id_cuentas + ' - ' + option.razon_social || ""}
      value={clienteSelectSimple}
      renderInput={(params) => (
        <TextField {...params}
          label="Cliente"
        // disabled={ editar || disabled? true : false}
        />
      )}


    />
  );
};
